// app/javascript/controllers/parallax_controller.js

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = ["image"]

  connect() {
    console.log("targets:", this.imageTargets)
    
    this.handleScroll = this.handleScroll.bind(this)
    window.addEventListener("scroll", this.handleScroll)

    this.handleScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll() {
    this.imageTargets.forEach((img) => {
      const rect = img.getBoundingClientRect()

      if (rect.top < window.innerHeight && rect.bottom > 0) {

        const offset = (window.innerHeight - rect.top) * 0.2

        img.style.transform = `translateY(${offset}px)`
      }
    })
  }
}
